import { RefreshCw } from "lucide-react";
import { fmtDate } from "@/lib/format";

const lastUpdate = (m) => {
  if (!m.last_refresh_at) return "—";
  const stored = m.last_result?.stored !== undefined ? ` · ${m.last_result.stored} ativos` : "";
  const failed = m.last_result && m.last_result.success === false ? ` · ${m.last_result.message}` : "";
  return `${fmtDate(m.last_refresh_at)}${stored}${failed}`;
};

export const EngineMarketRow = ({ market, data, busy, onRefresh }) => (
  <tr data-testid={`engine-row-${market}`} className="border-t border-[#1A1D25]">
    <td className="py-3 pr-6 font-mono text-white">{market}</td>
    <td className={`py-3 pr-6 font-mono text-xs uppercase ${data.live ? "text-[#10B981]" : "text-[#F59E0B]"}`}>
      {data.live ? "ao vivo" : "simulado"}
    </td>
    <td className="py-3 pr-6 font-mono text-xs text-[#94A3B8]">
      {data.providers.length ? data.providers.join(", ") : "—"}
      {data.note ? <span className="ml-2 text-[#64748B]">{data.note}</span> : null}
    </td>
    <td className="py-3 pr-8 text-right font-mono text-xs text-[#94A3B8]">{data.refresh_seconds}s</td>
    <td className="py-3 pr-6 font-mono text-xs text-[#94A3B8]">{lastUpdate(data)}</td>
    <td className="py-3 text-right">
      <button
        onClick={() => onRefresh(market)}
        disabled={!data.live || busy}
        data-testid={`engine-refresh-${market}`}
        className="inline-flex items-center gap-2 rounded-md border border-[#22252F] px-3 py-2 text-xs text-[#94A3B8] transition-colors hover:border-[#2563EB]/50 hover:text-white disabled:opacity-40"
      >
        <RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} />
        Atualizar
      </button>
    </td>
  </tr>
);
